import type { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';
import { isAffiliateWrappableItemType } from '@apps/registry/common/util/storeHelpers';

type ProductDialogRoutingArgs = Readonly<{
  product: CookedProduct;
  isDropshipable: boolean;
  syncedAffiliateCheckoutEnabled: boolean;
}>;

/**
 * Synced (externally owned) items used to always open the plain "go to store" SyncedProductDialog,
 * which has no gift wrap step. With the flag on, synced retail items take the affiliate checkout instead.
 */
export const shouldOpenSyncedProductDialog = ({ product, isDropshipable, syncedAffiliateCheckoutEnabled }: ProductDialogRoutingArgs): boolean => {
  if (!product.externallyOwned || isDropshipable) {
    return false;
  }
  const isRetailProduct = !product.donationFund && isAffiliateWrappableItemType(product.custom?.type ?? null);
  const canUseAffiliateCheckout = syncedAffiliateCheckoutEnabled && isRetailProduct && !!product.checkoutUrl;
  return !canUseAffiliateCheckout;
};
